import * as THREE from "three";

export interface JumpPose {
  position: THREE.Vector3;
  yaw: number;
}

/** Arc peak height scales gently with move distance so long knight leaps read as bigger jumps. */
export function jumpArcHeight(start: THREE.Vector3, end: THREE.Vector3): number {
  const distance = start.distanceTo(end);
  return 0.35 + distance * 0.12;
}

/**
 * Position and facing of the knight at progress `t` (0..1) of a single
 * jump. Uses a sine arc rather than a straight lerp so the knight visibly
 * leaves and returns to the board plane instead of sliding across it.
 */
export function sampleJumpPose(start: THREE.Vector3, end: THREE.Vector3, t: number): JumpPose {
  const clamped = Math.min(Math.max(t, 0), 1);
  const position = new THREE.Vector3().lerpVectors(start, end, clamped);
  position.y += Math.sin(Math.PI * clamped) * jumpArcHeight(start, end);

  const dx = end.x - start.x;
  const dz = end.z - start.z;
  const yaw = Math.abs(dx) + Math.abs(dz) > 1e-6 ? Math.atan2(dx, dz) : 0;
  return { position, yaw };
}

export function easeOutCubic(t: number): number {
  const clamped = Math.min(Math.max(t, 0), 1);
  return 1 - Math.pow(1 - clamped, 3);
}

export function easeInOutQuad(t: number): number {
  const clamped = Math.min(Math.max(t, 0), 1);
  return clamped < 0.5 ? 2 * clamped * clamped : 1 - Math.pow(-2 * clamped + 2, 2) / 2;
}
